import {
  SEARCH_RESULT_ROUTES,
  isInternalKreditLandingPath,
  isRentLandingPath
} from '../../utils/helpers/constants';

export const getSearchLandingPages = (pathname: string, asPath: string) => ({
  isSalePage:
    asPath === SEARCH_RESULT_ROUTES.SALE || isInternalKreditLandingPath(asPath),
  isRentPage: isRentLandingPath(asPath),
  isItemsAllPage: pathname === SEARCH_RESULT_ROUTES.ITEMS_ALL
});
